<script>
	export default {
		computed: {
			providers() {
				return this.$store.getters['providers/providers']
			},
			selected() {
				return this.$store.getters['providers/selectedProvider']
			}
		},
		methods: {
			selectProvider(provider) {
				this.$store.commit('providers/setSelectedProvider', provider)
			}
		}
	}
</script>

<template>
	<div class="prepaid-provider-selector" v-if="providers.length > 1">
		<div class="provider-card" v-for="p in providers" :key="p.id" :class="{'selected': p.id === selected.id}" @click.prevent="selectProvider(p)">
			<div class="card-header">
				<svg><use :href="`#provider-${p.slug}`"></use></svg>
			</div>
			<p class="card-footer">Approx {{ p.meta ? p.meta.lead_time_installation : `1 weeks` }} installation <sup>4</sup></p>
		</div>
	</div>
</template>
